import React from 'react';
export function SolutionSection() {
  return <section className="bg-gradient-to-b from-gray-950 to-gray-900 text-white py-16 px-4" data-id="element-180">
      <div className="max-w-4xl mx-auto text-center" data-id="element-181">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-182">
          El ciclista que va adelante no tiene mejor bici. Tiene mejor sistema.
        </h2>

        <p className="text-lg md:text-xl text-gray-300 mb-8" data-id="element-183">
          Ese del grupo que llega fresco a la cima mientras vos explotás no
          nació con piernas de otro planeta.
        </p>

        <p className="text-lg md:text-xl text-gray-300 mb-8" data-id="element-184">
          Come diferente. Se posiciona diferente. Pedalea diferente. Se recupera
          diferente.
        </p>

        <p className="text-lg md:text-xl font-semibold text-green-400 mb-12" data-id="element-185">
          Y ahora, por primera vez en Argentina, ese sistema completo está en un
          solo lugar.
        </p>

        <div className="bg-green-900 border-2 border-green-600 rounded-lg p-8" data-id="element-186">
          <h3 className="text-3xl font-bold mb-4" data-id="element-187">
            LA SOLUCIÓN: SISTEMA CICLISTA 360™
          </h3>
          <p className="text-xl font-semibold mb-4" data-id="element-188">
            El Protocolo Ruta Segura™
          </p>
          <p className="text-lg text-gray-200" data-id="element-189">
            El sistema que integra las 5 áreas que determinan tu rendimiento
            real como ciclista amateur argentino. Porque mejorar solo la
            nutrición sin mejorar la técnica es la mitad. Y la mitad no te lleva
            a la cima con el grupo.
          </p>
        </div>
      </div>
    </section>;
}